import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import { isMobile } from 'mobile-device-detect';

export default class ScroreScreen {
  constructor(camera, canvas) {}
  init() {
    this.processed = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('USER_EVENTS', this.onEvents.bind(this));

    document.querySelector('#tryAgain').addEventListener('click', () => {
      this.tryAgain();
    });
    document.querySelector('#tryAgain').addEventListener('touchstart', () => {
      this.tryAgain();
    });
    document.querySelector('#share').addEventListener('touchstart', () => {
      this.share();
    });
    document.querySelector('#share').addEventListener('click', () => {
      this.share();
    });
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'ScoreScreen') return false;

    this.processed = false;
    this.updateLeaderboard();
    document.querySelector(
      '#score_screen .scoreContainer #score .in'
    ).innerHTML = Global.pringlesCollected;

    document.querySelector('#score_screen').classList.add('active');

    gsap.delayedCall(0.0, () => {
      document.querySelector('#score_screen').classList.add('active2');
    });
    gsap.delayedCall(0.2, this.animateScreen.bind(this));
  }
  animateScreen() {
    gsap.delayedCall(0.0, () => {
      document.querySelector('#score_screen .header').classList.add('active');
    });
    gsap.delayedCall(0.1, () => {
      document.querySelector('#score_screen .logo').classList.add('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#score_screen .scoreText')
        .classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document.querySelector('#score_screen #score').classList.add('active');
    });
    gsap.delayedCall(0.35, () => {
      document
        .querySelector('#score_screen .leaderboardContainer .in')
        .classList.add('active');
    });
    gsap.delayedCall(0.7, () => {
      document.querySelector('#score_screen #tryAgain').classList.add('active');
    });
    gsap.delayedCall(0.8, () => {
      //

      document.querySelector('#score_screen #share').classList.add('active');
    });
  }
  hideScreen() {
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#score_screen .header')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document.querySelector('#score_screen .logo').classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#score_screen .scoreText')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document.querySelector('#score_screen #score').classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#score_screen .leaderboardContainer .in')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#score_screen #tryAgain')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document.querySelector('#score_screen #share').classList.remove('active');
    });
  }
  tryAgain() {
    if (this.processed) return;

    Global.soundEnabled && document.querySelector('#tapAudio').play();
    this.processed = true;
    this.hideScreen();
    Global.gameTry++;
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'replayClick',
      uniqID: Global.U_ID,
    });

    gsap.delayedCall(0.5, () => {
      document.querySelector('#score_screen').classList.remove('active');
      document.querySelector('#score_screen').classList.remove('active2');
      this.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'replay_game',
          data: {},
        },
      });
    });
  }
  async share() {
    Global.soundEnabled && document.querySelector('#tapAudio').play();

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'shareClick',
      uniqID: Global.U_ID,
    });
    var shareData = {
      title: 'Pringles: Pop Into Action',
      text: 'Run, play & share your score!',
      url: window.location.href,
    };
    if (navigator.share && navigator.canShare(shareData) && isMobile) {
      try {
        await navigator.share(shareData);
      } catch (err) {}
    } else {
      location.href = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
    }
  }
  updateLeaderboard() {
    setTimeout(() => {
      Global.serverObj.send(
        `${Global.BASE_URL}webservice.php`,
        (response) => {
          // response = JSON.parse(response)

          let data = response.leaderboard;

          // this.events.dispatchEvent({
          //   type: 'USER_EVENTS',
          //   message: {
          //     event_type: 'changeScreen',
          //     data: {
          //       curentScreen: 'form_screen',
          //       nextScreen: 'upload_screen',
          //     },
          //   },
          // });
          const container = document.querySelector('.rowsContainer');
          container.innerHTML = '';

          for (let i = 0; i < data.length; i++) {
            let child = `
    <div class="rows">
      <div class="rank">${i + 1}</div>
      <div class="name">${data[i].name}</div>
      <div class="score">${data[i].score}</div>
    </div>
  `;

            // ✅ Correct way to insert HTML string
            container.insertAdjacentHTML('beforeend', child);
          }
        },
        null,
        {
          saveType: 'leaderboard',
          uniqID: 12345678,
        },
        'POST',
        null,
        false
      );
    }, 1000);
  }
}
